import React from 'react';
import './Courses.css';

const COURSES = [
  {
    id: 1,
    emoji: '🪙',
    category: 'Crypto',
    title: 'Crypto Trading Masterclass',
    subtitle: 'From Zero to Crypto Pro',
    desc: 'Complete crypto trading course covering Bitcoin, Ethereum, altcoins, futures, DeFi, and Web3 investing strategies.',
    duration: '6 Weeks',
    level: 'Beginner to Advanced',
    modules: ['Blockchain & Crypto Fundamentals', 'Spot & Futures Trading', 'Technical Analysis for Crypto', 'DeFi & Yield Strategies', 'Risk Management', 'Portfolio Building'],
    price: '₹999',
    original: '₹1,999',
    tag: 'Bestseller',
    tagColor: '#f0b429',
  },
  {
    id: 2,
    emoji: '🇮🇳',
    category: 'Indian Market',
    title: 'Indian Stock Market Course',
    subtitle: 'NSE & BSE Complete Guide',
    desc: 'Deep dive into NSE/BSE equities, F&O trading, swing trading, and long-term investing strategies for the Indian market.',
    duration: '8 Weeks',
    level: 'Beginner to Advanced',
    modules: ['Stock Market Basics', 'Fundamental Analysis', 'Technical Analysis', 'F&O Strategies', 'Swing & Positional Trading', 'Taxation & Compliance'],
    price: '₹999',
    original: '₹1,999',
    tag: 'Popular',
    tagColor: '#10b981',
  },
  {
    id: 3,
    emoji: '📊',
    category: 'Technical Analysis',
    title: 'Price Action Mastery',
    subtitle: 'No Indicators. Pure Chart Reading.',
    desc: 'Learn to read markets using pure price action — candlestick patterns, support/resistance, order flow, and structure.',
    duration: '4 Weeks',
    level: 'Intermediate',
    modules: ['Candlestick Psychology', 'Support & Resistance', 'Market Structure', 'Entry & Exit Mastery', 'Multi-Timeframe Analysis', 'Live Trade Examples'],
    price: '₹899',
    original: '₹1,499',
    tag: 'New',
    tagColor: '#3b82f6',
  },
  {
    id: 4,
    emoji: '🧠',
    category: 'Psychology',
    title: 'Trading Psychology & Discipline',
    subtitle: 'Master Your Mind, Master the Market',
    desc: 'The course most traders skip but need the most. Learn stress management, emotional control, and mindset for consistent profits.',
    duration: '2 Weeks',
    level: 'All Levels',
    modules: ['Trader Psychology Basics', 'Fear & Greed Control', 'Journaling & Reflection', 'Stress Management', 'Building Consistency', 'Capital Protection Mindset'],
    price: '₹499',
    original: '₹999',
    tag: 'Essential',
    tagColor: '#8b5cf6',
  },
  {
    id: 5,
    emoji: '💰',
    category: 'Risk Management',
    title: 'Capital & Money Management',
    subtitle: 'Never Blow Your Account Again',
    desc: 'Professional-grade risk management strategies used by hedge funds and prop traders. Protect and grow your capital systematically.',
    duration: '3 Weeks',
    level: 'All Levels',
    modules: ['Position Sizing', 'Risk:Reward Ratios', 'Drawdown Management', 'Portfolio Allocation', 'Hedging Strategies', 'Capital Compounding'],
    price: '₹999',
    original: '₹1,999',
    tag: 'High Value',
    tagColor: '#f59e0b',
  },
  {
    id: 6,
    emoji: '🏆',
    category: 'Bundle',
    title: 'Complete Trader Bundle',
    subtitle: 'All Courses + Live Mentoring',
    desc: 'Get all 5 courses + 3 months of live trading calls + 1-on-1 mentoring sessions. The fastest path to consistent profits.',
    duration: '6 Months',
    level: 'All Levels',
    modules: ['All 5 Course Modules', '3 Months Live Calls', '4 Mentoring Sessions', 'Private Telegram Group', 'Priority Support', 'Lifetime Course Access'],
    price: '₹2,999',
    original: '₹4,999',
    tag: 'Best Value',
    tagColor: '#f0b429',
  },
];

const Courses = () => {
  const WHATSAPP_NUMBER = '919926749937';

  return (
    <div className="courses-page">
      <section className="page-hero section-padding grid-bg">
        <div className="hero-glow-small" />
        <div className="container">
          <div className="tag">Our Courses</div>
          <h1 className="section-title">Trading Courses That<br /><span className="gold-text">Actually Work</span></h1>
          <p className="section-subtitle">
            Practical, no-fluff courses built from real trading experience in Crypto and Indian markets.
            Learn what's working in today's markets.
          </p>
        </div>
      </section>

      <section className="courses-section section-padding">
        <div className="container">
          <div className="courses-grid">
            {COURSES.map((course) => (
              <div className="course-card card" key={course.id}>
                <div className="course-tag" style={{ borderColor: course.tagColor, color: course.tagColor }}>
                  {course.tag}
                </div>
                <div className="course-header">
                  <span className="course-emoji">{course.emoji}</span>
                  <span className="course-category">{course.category}</span>
                </div>
                <h3 className="course-title">{course.title}</h3>
                <p className="course-subtitle">{course.subtitle}</p>
                <p className="course-desc">{course.desc}</p>
                <div className="course-meta">
                  <span>⏱ {course.duration}</span>
                  <span>📶 {course.level}</span>
                </div>
                <div className="course-modules">
                  {course.modules.map((m, i) => (
                    <div className="module-item" key={i}>
                      <span className="module-check">✓</span>
                      <span>{m}</span>
                    </div>
                  ))}
                </div>
                <div className="course-footer">
                  <div className="course-price">
                    <span className="price-current">{course.price}</span>
                    <span className="price-original">{course.original}</span>
                    <span className="price-off">
                      {Math.round((1 - parseInt(course.price.replace(/[^0-9]/g,'')) / parseInt(course.original.replace(/[^0-9]/g,''))) * 100)}% OFF
                    </span>
                  </div>
                  <a
                    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Hi! I'm interested in the ${course.title} course.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-gold course-btn"
                  >
                    Enroll Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="courses-cta">
        <div className="container">
          <div className="courses-cta-inner">
            <h2 className="section-title">Not Sure Which Course?<br /><span className="gold-text">Talk to Us!</span></h2>
            <p>Our mentors will help you choose the right path based on your experience and goals.</p>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hi Kalpnic Trading! I need help choosing the right course for me.')}`}
              target="_blank"
              rel="noreferrer"
              className="btn-gold"
            >
              Get Free Guidance
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
